import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/Common/ProtectedRoute';
import MainLayout from './components/Layout/MainLayout';

import Login from './components/Auth/Login';
import Register from './components/Auth/Register';

import Dashboard from './components/Dashboard/Dashboard';
import CardManagement from './components/Dashboard/CardManagement';
import QRTopUp from './components/Dashboard/QRTopUp';
import CardTopUp from './components/Dashboard/CardTopUp';
import TransactionHistory from './components/Dashboard/TransactionHistory';
import { Toaster } from 'react-hot-toast';
function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster
            position="top-center"
            reverseOrder={false}
          />
        <Routes>

          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected App Shell */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            {/* Core Pages */}
            <Route index element={<Dashboard />} />
            <Route path="cards" element={<CardManagement />} />

            {/* Top-up Flow (UX: grouped journey) */}
            <Route path="topup">
              <Route index element={<CardTopUp />} />
              <Route path="card" element={<CardTopUp />} />
              <Route path="qr" element={<QRTopUp />} />
            </Route>

            <Route path="history" element={<TransactionHistory />} />
          </Route>

        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;